// Pure GST calculation functions — no Firestore/React imports.
import { round } from "./whtCalculator";

export const GST_SCOPES = Object.freeze({
  SERVICE_CHARGES_ONLY: "SERVICE_CHARGES_ONLY",
  FULL_INVOICE: "FULL_INVOICE"
});

// Matches cortevaWorkbook.js:84 (`Math.round(serviceCharges * 0.16)`) for the
// SERVICE_CHARGES_ONLY scope, and IILInvoice.js:690/780
// (`invoiceAmount * 0.16`) for the FULL_INVOICE scope.
export function calculateGst({ scope, serviceCharges = 0, fullInvoiceAmount = 0, gstRate }) {
  const rate = Number(gstRate || 0);
  if (scope === GST_SCOPES.FULL_INVOICE) {
    return round(Number(fullInvoiceAmount || 0) * rate);
  }
  return round(Number(serviceCharges || 0) * rate);
}

export function calculateGrossAmount({ invoiceAmount, gstAmount }) {
  return round(Number(invoiceAmount || 0)) + round(Number(gstAmount || 0));
}

// GST balance = Output GST - recognized GST withholding - eligible input GST
// - GST deposited +/- approved adjustments (requirement 13). Adjustments are
// unsigned amounts tagged CREDIT (reduces payable, e.g. a credit note in
// ALM's favor) or DEBIT (increases payable) rather than pre-signed numbers,
// so the ledger UI never has to remember a sign convention.
export function calculateGstBalance({
  outputGst = 0, recognizedGstWithheld = 0, inputGstCredit = 0, gstDeposited = 0, adjustments = []
}) {
  const netAdjustment = adjustments.reduce(
    (sum, a) => sum + (a.type === "CREDIT" ? -Number(a.amount || 0) : Number(a.amount || 0)),
    0
  );
  return round(
    Number(outputGst || 0)
    - Number(recognizedGstWithheld || 0)
    - Number(inputGstCredit || 0)
    - Number(gstDeposited || 0)
    + netAdjustment
  );
}
